import RevealUp from './RevealUp';
import '../styles/Footer.css';

export default function Footer({ zIndex = 7 }) {
  return (
    <footer className="site-footer section-cover" style={{ zIndex }}>
      <div className="site-footer__top">
        <div className="site-footer__social">
          <a href="https://x.com/botifycloud" target="_blank" rel="noopener noreferrer" aria-label="X">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M18.9 2H22l-7.6 8.7L23.3 22H16.9l-5-6.5L6 22H2.9l8.1-9.3L1.9 2h6.6l4.5 6z" />
            </svg>
          </a>
          <a href="https://t.me/botifycloud" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M21.5 3.5 2.7 10.9c-1.1.44-1.1 1.06-.2 1.34l4.8 1.5 1.9 5.8c.24.6.4.85.8.85.3 0 .45-.14.64-.33l1.9-1.83 4 2.94c.73.4 1.26.2 1.44-.68l2.6-12.3c.27-1.1-.4-1.6-1.24-1.68z" />
            </svg>
          </a>
        </div>
        <a href="/terms" className="site-footer__terms">
          TERMS
        </a>
      </div>

      <div className="site-footer__rule" />

      <div className="site-footer__meta">
        <span>@2026 BOTIFY</span>
        <span>BUILT BY BOTZO</span>
      </div>

      <RevealUp className="site-footer__wordmark-wrap">
        <span className="site-footer__wordmark">BOTIFY</span>
      </RevealUp>
    </footer>
  );
}